export default "__VITE_ASSET__ZsJPw5C3__"